const { REACT_APP_BUCKET_S3_RESOURCES } = process.env;
function getPlatformLogo(systemName) {
  return `${REACT_APP_BUCKET_S3_RESOURCES}/logos/platforms/${systemName}/main.png`;
}
export default getPlatformLogo;
